<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiAccountArrowUp } from "@mdi/js";
export default {
  name: "MdiAccountArrowUp",
  data() {
    return {
      svgPath: mdiAccountArrowUp,
    };
  },
};
</script>
